export const receiptList = "RECEIPT_LIST";
